<script setup lang="ts">
import { onMounted, onBeforeMount } from 'vue'
import router from '@/router'

onBeforeMount(() => {
  let status = localStorage.getItem('userStatus')
  if (status !== 'OnboardProgress') {
    router.push({ name: 'student.app' })
  }
})
</script>

<template>
  <RouterView />
</template>
